export const deviceWidth = {
    mobile: 376,
    mobileM: 481,
    mobileL: 551,
    tablet: 769,
    tabletL: 991,
    tabletXl: 1024,
    desktop: 1081,
};

export const sizeConstants = {
    containerMaxWidth: 1300,
    mobileLRContainerPadding: 15,
};

export const device = {
    mobile: `@media (min-width: ${deviceWidth.mobile}px)`,
    mobileM: `@media (min-width: ${deviceWidth.mobileM}px)`,
    mobileL: `@media (min-width: ${deviceWidth.mobileL}px)`,
    tablet: `@media (min-width: ${deviceWidth.tablet}px)`,
    tabletL: `@media (min-width: ${deviceWidth.tabletL}px)`,
    upToDesktop: `@media (max-width: ${deviceWidth.desktop}px)`,
    upToTabletL: `@media (max-width: ${deviceWidth.tabletL}px)`,
    upToTabletXl: `@media (max-width: ${deviceWidth.tabletXl}px)`,
    desktop: `@media (min-width: ${deviceWidth.desktop}px)`,
    containerMaxWidth: `@media (min-width: ${
        sizeConstants.containerMaxWidth + sizeConstants.mobileLRContainerPadding * 2
    }px)`,
};
